import { keyframes } from 'styled-components';
import overrideStyle from 'lib/overrideStyle';
import PropTypes from 'prop-types';
import React from 'react';

import getRadius from 'lib/getRadius';
import { useHover } from 'presentation/hooks/hover';

const validImageTypes = ['image/gif', 'image/jpeg', 'image/png'];

export default function ImagePreview(props) {
  const [callbacks, isHovered] = useHover();

  const handlePreviewDisplay = () => {
    if (validImageTypes.includes(props.fileType)) {
      return (
        <ImageDisplay
          data-aid="gladlyAttachment"
          src={props.src}
          alt={props.alt || ''}
          onClick={() => true}
          onKeyDown={() => true}
          tabIndex="0"
        />
      );
    } else {
      return (
        <OtherExtensionDisplay data-aid="gladlyAttachment" onClick={() => true} onKeyDown={() => true} tabIndex="0">
          {props.fileName}
        </OtherExtensionDisplay>
      );
    }
  };

  return (
    <Wrapper {...callbacks}>
      {isHovered ? (
        <CloseButton
          data-aid="gladlyCloseAttachmentButton"
          onClick={() => props.onCloseImage(props.number)}
          onKeyDown={() => true}
          role="button"
          tabIndex="0"
        >
          <CloseIcon>
            <svg width="6" height="6" viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 1L5 5" stroke="black" strokeWidth="0.571429" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M5 1L1 5" stroke="black" strokeWidth="0.571429" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </CloseIcon>
        </CloseButton>
      ) : null}
      {handlePreviewDisplay()}
    </Wrapper>
  );
}
ImagePreview.propTypes = {
  alt: PropTypes.string,
  fileType: PropTypes.string.isRequired,
  fileName: PropTypes.string,
  onCloseImage: PropTypes.func.isRequired,
  src: PropTypes.string.isRequired,
};

const fadeIn = keyframes`
  from {
    transform: translateY(10px);
    opacity: 0;
  }

  to {
    transform: initial;
    opacity: 1;
  }
`;

const ImageDisplay = overrideStyle('img')`
  animation: ${fadeIn} .5s ease-out;
  border-radius: ${p => getRadius(p.theme.borderRadius, 4, 8)};
  height: 50px;
  width: 70px;
  margin: 8px;
  object-fit: cover;
`;

const CloseButton = overrideStyle('div')`
  cursor: pointer;
  background-color: #ffffff;
  border-radius: 50px;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
  height: 22px;
  margin: 0px 0px 0px 72px;
  position: absolute;
  width: 22px;

  &:active{
    outline: none;
  }
  &.visible {
    visibility: visible;
    opacity: 1;
    transition: opacity 2s linear;
  }
  &.hidden {
    visibility: hidden;
    opacity: 0;
    transition: visibility 0s 2s, opacity 2s linear;
  }
`;
const Wrapper = overrideStyle('div')`
  height: 60px;
  width: 90px;
  position: relative;
`;
const OtherExtensionDisplay = overrideStyle('div')`
  background-color: ${p => p.theme.colors.attachmentBackground};
  border-radius: ${p => getRadius(p.theme.borderRadius, 4, 8)};
  color: white;
  font-size: 8px;
  height: 46px;
  margin: 8px;
  padding: 4px;
  width: 66px;
  word-wrap: break-word;
`;

const CloseIcon = overrideStyle('div')`
  border-radius: 100px;
  cursor: pointer;
  height: 6px;
  padding: 0px 0px 0px 8px;
  position: absolute;
  width: 6px;

  &:active{
    outline: none;
    color: ${p => p.theme.colors.submitArrow || p.theme.colors.brandPrimary || '#555555'};
  }
  &:focus{
    outline: none;
    color: ${p => p.theme.colors.submitArrow || p.theme.colors.brandPrimary || '#555555'};
  }
  &:hover{
    outline: none;
    color: ${p => p.theme.colors.submitArrow || p.theme.colors.brandPrimary || '#555555'};
  }
`;
